import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../shared/api-service/api.service';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HelpersService } from '../../../shared/helpers/helpers.service';
import { SearchService } from '../../../shared/search/search.service';
import { ComponentID, ActionType, PermissionHelper } from '../../../shared/helpers/permissionshelper';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Logging } from '../../../logging';
import { Subject } from 'rxjs/Subject';

declare var jquery:any;
declare var $ :any;
declare var App:any;
declare var FormSliderSwitcher:any;

@Component({
  selector: 'app-banks',
  templateUrl: './banks.component.html',
  styleUrls: []
})
export class BanksComponent implements OnInit {
  
  bankslist:any [];
  bankbranches: any[];
  inputform:  FormGroup;
  showErrors :Boolean = false;
  loading: boolean;
  hasError: boolean;
  errorMessage: any;
  successMessage : any;

  currPage: number = 1;
  totalItems: number;
  itemsPerPage: number;
  search_term: any = '';
  searchTerm$ = new Subject<string>();
  savedbanks:any[];
  editid: number  = 0;
  editedbank : any = null;
  selectedbranch: any;
  
  
  activeRoute = 'banks';
  
  constructor(private api: ApiService,
    private auth: AuthService,
    private router: Router,
    private helpers: HelpersService,
    private searchService: SearchService,private componentid : ComponentID ,
    private actiontype: ActionType,private permhelper:PermissionHelper, private route: ActivatedRoute) { }

    
  ngOnInit() {

    this.inputform = new FormGroup({
      bankid: new FormControl('',Validators.required),
      bankbranchid: new FormControl(false,Validators.required),
      sortcode: new FormControl('',Validators.required),
      accountname: new FormControl('', Validators.required),
      accountnumber: new FormControl('', [Validators.required,
        Validators.pattern("[0-9]*"),
        Validators.minLength(5), 
        Validators.maxLength(20)]),
      swiftcode: new FormControl(),
    });
    $(".default-select2").select2();

    //Setup the list
    this.getData(0);

    this.searchService.search(this.searchTerm$)
      .subscribe(results => {
         Logging.log('search triggered');
        this.search_term = results;
        this.getData(0)
      });


    //Fetch the available banks in GH
    this.api.get('/options/banks')
    .subscribe(
      res_data => {
     //  Logging.log(res_data.data);

      //Collect the services if the request was successful and there was data retured.
      if(res_data.status == "SUCCESS" && res_data.data.length > 0 ){
       this.bankslist = res_data.data;
       Logging.log(res_data.data);

      }

      
      }, error_message => {
       //  this.loading = false;
       //  this.hasError = true;
      this.helpers.flashDanger('An error has occured. Please refresh page or try again later');
      }
    );


    //catch the select 2 onchange event
    var self = this;
    $('#bankname').on("change", function() { 
      self.getSelectBankBranches($(this).val());
      self.setBankName($(this).val());
   });

   $('#branch').on("change", function() { 
     self.setSortCode($(this).val()); 
     self.setBranchName($(this).val());
    
    });

    // get URL parameters
    this.route.params.subscribe(params => {
      if(params['bankid']){
        this.editid = params['bankid'];
        this.fetchBankForEdit(params['bankid']);
      }
       
    });


  }

  fetchBankForEdit(id:number)
  {
    this.api.get('/accounts/'+this.auth.getAccountID()+'/bankaccounts/'+id)
    .subscribe(
      res_data => {
        Logging.log(res_data.data);
        this.editedbank = res_data.data[0];
        this.inputform.controls.bankid.setValue(res_data.data[0].bankid);
        this.inputform.controls.bankbranchid.setValue(res_data.data[0].branchid);
        this.inputform.controls.sortcode.setValue(res_data.data[0].sortcode);
        this.inputform.controls.accountname.setValue(res_data.data[0].accountname);
        this.inputform.controls.accountnumber.setValue(res_data.data[0].accountnumber);
        this.inputform.controls.swiftcode.setValue(res_data.data[0].swiftcode);
        
        this.selectedbranch = res_data.data[0].branchid;
       
       this.helpers.sleep(200).then(() => { // wait smal so that things will settle
        $("#bankname").select2("val", res_data.data[0].bankid);
      });
       


      }, error_message => {
       //  this.loading = false;
       //  this.hasError = true;
      this.helpers.flashDanger('An error has occured. Please refresh page or try again later');
      }
    );
  }


  getData(page:number){
  
    this.loading = true;
    window.scrollTo(0, 0);
    //Fetch all users
    this.api.get('/accounts/'+ this.auth.getAccountID() + '/bankaccounts' + '?sort=createddate,desc&search='+this.search_term+'&page=' + page)
    .subscribe(
      res_data => {
      Logging.log(res_data.data);
      this.savedbanks = res_data.data.content;
      this.totalItems = res_data.data.totalElements;
      this.itemsPerPage = res_data.data.size;
      this.currPage = res_data.data.number;
      this.loading = false;
      
      }, error_message => {
        this.loading = false;
       //  this.hasError = true;
       //  this.errorMessage = error_message;
      }
    );
  }

  setBankName(id:number)
  {
    //const bdata = this.bankslist.filter(f => f.id == id);
   // this.inputform.controls.bankname.setValue(bdata[0].name);
   this.inputform.controls.bankid.setValue(id);
  }

  setBranchName(branchid:number)
  {
    /*const bdata = this.bankbranches.filter(f => f.id == branchid);
    if(bdata && bdata.length > 0)
    {
      this.inputform.controls.bankbranch.setValue(bdata[0].branch);
    }
    */

    this.inputform.controls.bankbranchid.setValue(branchid);
  }

  setSortCode(branchid : number)
  {
    const bdata = this.bankbranches.filter(f => f.id == branchid);
    if(bdata && bdata.length > 0)
    {
      this.inputform.controls.sortcode.setValue(bdata[0].sortcode);
    }
   
  }

  getSelectBankBranches(bankid: number)
  {
    //Fetch the available banks in GH
    this.api.get('/options/banks/'+bankid + "/branches")
    .subscribe(
      res_data => {
      if(res_data.status == "SUCCESS" && res_data.data.length > 0 ){
       this.bankbranches = res_data.data;
       Logging.log(res_data.data);
        //wait small so that the branches are updated
        this.helpers.sleep(500).then(() => {
          //$("#branch").select2("val", $("#branch option:contains("+this.selectedbranch +")").val());
          $("#branch").select2("val", this.selectedbranch);
        });
     
      }

      
      }, error_message => {
       //  this.loading = false;
       //  this.hasError = true;
      this.helpers.flashDanger('An error has occured. Please refresh page or try again later');
      }
    );
  }

  

  onSubmit(){
    //Set loading to true to show loader
    this.loading = true;
    this.hasError = false;

    if(this.inputform.valid){
      Logging.log(this.inputform.value);
      const regfields = this.inputform.value;

      const requestpayload = {
        accountid: this.auth.getAccountID(),
        accountname: regfields.accountname,
        accountnumber : regfields.accountnumber,
        bankid : regfields.bankid,
        branchid : regfields.bankbranchid,
        sortcode : regfields.sortcode,
        swiftcode :regfields.swiftcode
      };

      if(this.editid > 0)
      {
        requestpayload['id'] = this.editid;
        requestpayload['createdby'] = this.editedbank.createdby;
        requestpayload['createddate'] = this.editedbank.createddate;
      }
   
      //Save details the sub user
      const routeidadd:any = this.editid > 0 ? "/"+this.editid : "";
      const method : string = this.editid > 0 ? "PUT": "POST";

      this.api.request('/accounts/' + this.auth.getAccountID() + '/bankaccounts'+routeidadd, method, requestpayload)
      .subscribe(
        res_data => {
        Logging.log(res_data.data);
        this.helpers.flashSuccess('Bank details saved successfully');

        if(method == 'POST')
        {
          this.router.navigate(['/account/banks/'+res_data.data[0].id+"/edit"]);
        }
        else
        {
          this.router.navigate(['/account/banks']);
        }

        this.loading = false;
        this.hasError = false;
          
        }, error_message => {
          this.loading = false;
          this.hasError = true;
          this.errorMessage = error_message;
        }
      );
      

    }
    else
    {
      this.loading = false;
      this.hasError = false;

      this.showErrors = true;
      Logging.log('Has Errors', this.inputform.value);
    }
  }

  clearErrors()
  {
    this.hasError = false;
    this.errorMessage ="";
    this.loading= false;
  }

}



// WEBPACK FOOTER //
// ./src/app/client/account/banks/banks.component.ts